import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { UserImageModelInstance } from 'src/store/_models/userImage';

type WithActiveUserImageAreaProps<P> = P & {
  activeUserImageArea: UserImageModelInstance;
};

type withoutActiveUserImageAreaProps<P> = Omit<P, 'activeUserImageArea'>;

export function withActiveUserImageArea<P extends object>(
  Component: React.ComponentType<WithActiveUserImageAreaProps<P>>,
) {
  return observer((props: withoutActiveUserImageAreaProps<P>) => {
    const {
      project: { activeUserImageArea },
    } = useStore();
    if (activeUserImageArea) {
      const newComponentProps = {
        ...props,
        activeUserImageArea: activeUserImageArea,
      } as WithActiveUserImageAreaProps<P>;
      return <Component {...newComponentProps} />;
    } else {
      return null;
    }
  });
}
